import React, { useEffect } from "react";

import { Spin } from "antd";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

import { APIRequest } from "@companion-core/shared/app/Interfaces/API";
import { RequestCard } from "@companion-core/shared/app/Components/Requests";
import { Button } from "@companion-core/shared/app/Components/Button";
import { useBellStore } from "@companion-core/shared/app/Store/bellStore";
import { trackClickRequestDetail } from "@companion-core/shared/app/tracking/requests";
import { useConfigStore } from "@companion-core/shared/app/Store/configStore";
import { RequestListProps } from "./RequestList.model";

import "Assets/Styles/scss/myRequests.scss";

export const RequestList = ({
  data,
  initialTabIndex,
  requestsFetched,
  activeKey,
  setActiveKey,
}: RequestListProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setIsPopUpVisible } = useBellStore((state) => ({
    setIsPopUpVisible: state.setIsPopUpVisible,
  }));
  const { config } = useConfigStore();
  const noRequestsButtonAction =
    config?.modules?.concierge?.modules["my-requests"].noRequestsButtonAction;

  useEffect(() => {
    if (initialTabIndex && setActiveKey) setActiveKey(initialTabIndex);
  }, []);

  if (requestsFetched && data) {
    const total = data.length;
    return total > 0 ? (
      <ol data-testid="my-requests__list" className="my-requests__list" role="list">
        {data?.map((value: APIRequest, index: number) => (
          <li
            key={value.id}
            className="request-card__wrapper"
            aria-setsize={total}
            aria-posinset={index + 1}>
            <RequestCard
              path={`/my-requests/${value.id}/details/detail`}
              key={value.id}
              data={value}
              accessibilityLabel={t("request.my-requests.card.accessibility-label", {
                position: index + 1,
                total,
              })}
              onClick={() => {
                trackClickRequestDetail({
                  family: value.family,
                  subFamily: value.sub_family,
                  vendorId: value.vendor?.vendor_id,
                  requestId: value.id,
                  status: value.status,
                });
              }}
            />
          </li>
        ))}
      </ol>
    ) : (
      <div className="my-requests__no-request" data-testid="my-requests__no-request">
        <p
          className="body-text-4 my-requests__no-request-label"
          data-testid="my-requests__no-request-label">
          {activeKey == 0
            ? t("request.my-requests.no-requests.on-going")
            : t("request.my-requests.no-requests.done")}
        </p>
        <Button
          classNames={["my-requests__no-request-button"]}
          label={`${t("request.my-requests.no-requests.button.label")}`}
          testID="my-requests__no-request-button"
          onClick={() => {
            if (noRequestsButtonAction === "navigateToOfferList") {
              navigate("/offers");
            } else {
              setIsPopUpVisible(true);
            }
          }}
        />
      </div>
    );
  } else
    return (
      <div className="my-requests__no-request">
        <Spin data-testid="my-requests__loader" size="large" />
      </div>
    );
};
